export const getVariable = (varName) => {
  const query = window.location.search.substring(1);
  const vars = query.split('&');

  for (var i=0, length=vars.length; i<length; i++) {
    const entry = vars[i].split('=');
    if (entry[0] === varName) return entry[1];
  }

  return false;
};

export const elementExist = (elementName, returnElement = false) => {
  const element = document.querySelector(elementName);

  if (typeof element !== 'undefined' && element) {
    if (returnElement) return element;
    return true;
  }
  return false;
};

export const elementsExist = (elementsName, returnElements = false) => {
  const elements = document.querySelectorAll(elementsName);

  if (typeof elements !== 'undefined' && elements.length > 0) {
    if (returnElements) return elements;
    return true;
  }
  return false;
};

export const error = (message = '', fieldName = '') => {
  const error = { isError: true };

  if (message) error['message'] = message;
  if (fieldName !== '') addError(message, fieldName);

  return error;
};

const addError = (message, fieldName) => {
  const field = document.querySelector(`[name="${fieldName}"]`);
  if (!field) return false;

  let fieldParent = field.parentNode;

  const error = document.createElement('div');
  error.classList.add('error');
  error.innerText = message;

  fieldParent.classList.add('error');
  fieldParent.appendChild(error);
};

export const resetError = (fieldName) => {
  const field = document.querySelector(`[name="${fieldName}"]`);
  if (!field) return false;

  const parent = field.parentElement;
  parent.classList.remove('error');

  const errorInfo = parent.querySelector('.error');
  if (!errorInfo) return false;

  errorInfo.remove();
};

export const resetErrors = (wrap) => {
  const errorsGroup = wrap.querySelectorAll('.error.form-group');
  const errors = wrap.querySelectorAll('.error:not(.form-group)');
  if (errorsGroup.length > 0) {
    errorsGroup.forEach(error => error.classList.remove('error'));
  }
  if (errors.length > 0) {
    errors.forEach(error => error.remove());
  }
};